import Api from "@/services/Api";

export default {
  indexByUser(userId) {
    return Api().get("characters/by_user/" + userId);
  },
  updateUser(characterId, userId) {
    return Api().put("/characters/" + characterId + "/update_user/" + userId);
  },
  store(form) {
    return Api().post("characters", form);
  },
  destroy(characterId) {
    return Api().delete("characters/" + characterId);
  },
  alterGold(characterId, form) {
    return Api().put("characters/" + characterId + "/alter_gold", form);
  },
  alterExperience(characterId, form) {
    return Api().put("characters/" + characterId + "/alter_experience", form);
  },
  levelUpToProsperity(characterId) {
    return Api().get("characters/" + characterId + "/level_up_to_prosperity");
  },
  verifyLeveledUp(characterId) {
    return Api().get("characters/" + characterId + "/verify_leveled_up");
  },
  setPerks(characterId, form) {
    return Api().put("characters/" + characterId + "/set_perks", form);
  },
  raisePerkChecks(characterId) {
    return Api().get("characters/" + characterId + "/raise_perk_checks");
  },
  lowerPerkChecks(characterId) {
    return Api().get("characters/" + characterId + "/lower_perk_checks");
  },
  retire(characterId) {
    return Api().get("characters/" + characterId + "/retire");
  },
  view(characterId) {
    return Api().get("characters/" + characterId);
  },
  buyItem(characterId, itemId) {
    return Api().put("characters/" + characterId + "/buy_item/" + itemId);
  },
  grantItem(characterId, itemId) {
    return Api().put("characters/" + characterId + "/grant_item/" + itemId);
  },
  sellItem(characterId, itemId) {
    return Api().put("characters/" + characterId + "/sell_item/" + itemId);
  },
  removeItem(characterId, itemId) {
    return Api().put("characters/" + characterId + "/remove_item/" + itemId);
  },
  updateNotes(characterId, form) {
    return Api().put("characters/" + characterId + "/update_notes", form);
  },
  donate(characterId) {
    return Api().put("characters/" + characterId + "/donate");
  }
};